module.exports = __webpack_public_path__ + "static/media/CACPE_LOJA.92c3b8e2.png";